import React, { useState } from 'react';
import {
  Button,
  Card,
  Container,
  Divider,
  Form,
  Grid,
  Header,
  Message,
  MessageHeader
} from 'semantic-ui-react';
import styles from './Questionnaire.style.module.css';
import { getPartnerAsync } from '../../Stores/PartnerStore'

export interface IPartnerCodeStep {
  onSave: (partnerCode: string) => void;
}

export const PartnerCodeStep: React.FC<IPartnerCodeStep> = ({
  onSave,
}) => {
  const [groupCode, setGroupCode] = useState<string>('');
  const [warning, setWarning] = useState<boolean>(false)
  const handlePartner = async () => {
    try {
      setWarning(false)
      const val = await getPartnerAsync(groupCode, true)
      if (val?.partnerId != null) {
        onSave(groupCode)
      } else {
        setWarning(true)
      }
    } catch (error) {
      setWarning(true)
    }
  }

  return (
    <>
      <Card.Header>
        <Container id={styles['custom-container']}>
          <Grid.Row className={styles['custom-row']}>
            <Header style={{ margin: 0, paddingBottom: 20 }} as={'h1'}>
              Do you have a group code?
            </Header>
            <Header.Subheader style={{ margin: 0, paddingBottom: 20, fontSize: "1.35em" }}>A group code is a 6 digit number provided by your organization which will tailor your experience.</Header.Subheader>
          </Grid.Row>
        </Container>
        <Header>Enter your group code below: </Header>
      </Card.Header>
      <Divider />
      <Form>
        <Grid>
          <Grid.Row columns={1}>
            <Grid.Column>
              <Form.Input
                input={{
                  'data-testid': 'groupCode',
                }}
                value={`${groupCode}`}
                onChange={(e) => {
                  setGroupCode(e.target.value);
                }}
                type='text'
                iconPosition='left'
                label='Group Code'
              />
            </Grid.Column>
            {warning && (
              <Grid.Column style={{ marginTop: '3px'}}>
                <Message negative >
                  <MessageHeader>
                    Sorry, that is not a valid Partner Code
                  </MessageHeader>
                </Message>
              </Grid.Column>
            )}
            <Grid.Column textAlign='right' id={styles['double-cta']}>
              <Button
                primary
                onClick={handlePartner}
                disabled={groupCode === ''}
                style={{ marginRight: '0px' }}

              >
                Proceed
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </>
  );
};
